<template>
  <div class="hello">
    <div class="row">
      <div class="col-1" style="margin-right: auto">
        <h3 class="form-head">Dashboard</h3>
      </div>
      <div class="col-auto">
        <form class="form-inline" v-on:submit.prevent>
          <select v-model="period" class="form-control">
            <option value="current">Current Month</option>
            <option value="last">Previous Month</option>
            <option value="custom">Custom Date Range</option>
          </select>
          <date-picker v-model="fromDate" :config="options" v-if="period === 'custom'"></date-picker>
          <date-picker v-model="toDate" :config="options" v-if="period === 'custom'"></date-picker>
          <b-dropdown size="sm" variant="outline-secondary" id="dropdown-form"
                      :text="saleTypeText" ref="dropdown" class="m-2">
            <b-dropdown-form>
              <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="saleType"
              :options="saleTypes"
              name="flavour-1"
            ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
          <select class="form-control" v-model="group" @change="groupChanged()" v-if="isAdmin || isUser">
            <option :value="0">All Groups</option>
            <option v-for="l of groups" :value="l" :key="l">{{l}}</option>
          </select>
          <select class="form-control" v-model="division" v-if="isAdmin || isUser" :disabled="group === 0">
            <option :value="0">All Divisions</option>
            <option v-for="l of divisions" :value="l" :key="l">{{l}}</option>
          </select>
          <select class="form-control" v-model="location" v-if="isAdmin || isUser">
            <option :value="0">All Locations</option>
            <option v-for="l of locations" :value="l.id" :key="l.id">{{l.name}} &ndash; {{l.codes.join(",")}}</option>
          </select>
          <select class="form-control" v-model="transporter" v-if="isAdmin || isUser">
            <option :value="0">All Transporters</option>
            <option v-for="l of transporters" :value="l.id" :key="l.id">{{l.name}}</option>
          </select>
          <select class="form-control" v-if="isAdmin" v-model="aggregate">
            <option value="COUNT">Invoice Counts</option>
            <option value="SUM">Invoice Values (in Lacs)</option>
          </select>
          <button class="btn btn-primary btn-sm mt-1" @click="loadDashboard">
            <span v-if="!updating"><i class="fa fa-sync"></i> Update</span>
            <span v-if="updating"><i class="fa fa-sync fa-spin"></i> Updating</span>
          </button>
        </form>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-12 pod-home-page">

        <div class="card-deck">
          <div class="card text-white" :style="makeBGColor(0)">
            <div class="card-header" >
              <a :href="getUrl('created')" class=" text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="far fa-truck-loading fa-2x"></i></div>
                      <div class="col text-right small">{{pods.created}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Created
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div class="card text-white" :style="makeBGColor(6)">
            <div class="card-header " >
              <a :href="getUrl('cancelled')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="far fa-ban fa-2x"></i></div>
                      <div class="col text-right small">{{pods.cancelled}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Cancelled
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card text-white" :style="makeBGColor(9)">
            <div class="card-header " >
              <a :href="getUrl('services')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="far fa-clipboard-check fa-2x"></i></div>
                      <div class="col text-right small">{{pods.noshipping}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Service Invoice (NPD)
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card text-white text-white" :style="makeBGColor(1)">
            <div class="card-header " >
              <a :href="getUrl('shipped')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="far fa-shipping-fast fa-2x"></i></div>
                      <div class="col text-right small">{{pods.shipped}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Shipped
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card text-white" :style="makeBGColor(2)">
            <div class="card-header " >
              <a :href="getUrl('delivered')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="far fa-box-check fa-2x"></i></div>
                      <div class="col text-right small">{{pods.delivered}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Delivered
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div class="card text-white" :style="makeBGColor(7)">
            <div class="card-header " >
              <a :href="getUrl('returned')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="far fa-undo fa-2x"></i></div>
                      <div class="col text-right small">{{pods.returned}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Returned
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card text-white" :style="makeBGColor(3)">
            <div class="card-header " >
              <a :href="getUrl('uploaded')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="fa fa-upload fa-2x"></i></div>
                      <div class="col text-right small">{{pods.uploaded}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    POD Uploaded
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card text-white" :style="makeBGColor(5)">
            <div class="card-header " >
              <a :href="getUrl('undelivered')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="fa fa-exclamation-triangle fa-2x"></i></div>
                      <div class="col text-right small">{{pods.undelivered}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    In-Transit
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div class="card text-white" :style="makeBGColor(4)">
            <div class="card-header " >
              <a :href="getUrl('pending')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="fa fa-clock fa-2x"></i></div>
                      <div class="col text-right small">{{pods.pending}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    POD Pending
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="card text-white d-none" :style="makeBGColor(8)">
            <div class="card-header " >
              <a :href="getUrl('disputed')" class="text-white">
                <div class="row">
                  <div class="col-12">
                    <div class="row justify-content-between">
                      <div class="col"><i class="fa fa-times-hexagon fa-2x"></i></div>
                      <div class="col text-right small">{{pods.disputed}}</div>
                    </div>
                  </div>
                  <div class="col-12 text-right mt-2 text-uppercase small">
                    Damaged/Short
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="row">
      <div class="col-12">
        <b-card>
          <b-tabs card pills align="center" v-model="activeTab" @input="tabChanged">
            <b-tab title="Overall">
              <div class="row mt-1">

                <div class="col-6">
                  <table class="table table-borderless table-hover table-sm">
                    <thead class="thead-light">
                    <tr>
                      <th>Category</th>
                      <th v-for="m of trends" :key="m.month">{{m.month}}</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!isTransporter">
                        <td>Total Invoices Generated</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'created')">
                            {{t.dashboardEntry.created}}
                          </a>
                        </td>
                      </tr>
                      <tr v-if="!isTransporter">
                        <td>Service Invoice (NPD)</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'services')">
                            {{t.dashboardEntry.noshipping}}
                          </a>
                          <br />
                          <span class="text-black-50">({{t.dashboardEntry.noshipping_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr v-if="!isTransporter">
                        <td>Invoices Cancelled</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'cancelled')">
                            {{t.dashboardEntry.cancelled}}
                          </a>
                          <br />
                          <span class="text-black-50">({{t.dashboardEntry.cancelled_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Shipped Invoices</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'shipped')">
                            {{t.dashboardEntry.shipped}}
                          </a>
                          <br />
                          <span class="text-black-50">({{t.dashboardEntry.shipped_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Shipments Delivered to Customer</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'delivered')">
                            {{t.dashboardEntry.delivered}}
                          </a>
                          <br />
                          <span class="text-black-50">({{t.dashboardEntry.delivered_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>POD Uploaded</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'uploaded')">
                            {{t.dashboardEntry.uploaded}}
                          </a>
                          <br />
                          <span class="text-black-50">({{t.dashboardEntry.uploaded_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>POD Upload Pending</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'pending')">
                            {{t.dashboardEntry.pending}}
                          </a>
                          <br />
                          <span class="text-danger">({{t.dashboardEntry.pending_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>In-Transit OR Update Pending</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'undelivered')">
                            {{t.dashboardEntry.undelivered}}
                          </a>
                          <br />
                          <span class="text-danger">({{t.dashboardEntry.undelivered_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Shipments Returned To Warehouse</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'returned')">
                            {{t.dashboardEntry.returned}}
                          </a>
                          <br />
                          <span class="text-black-50">({{t.dashboardEntry.returned_pct|toPct}}%)</span>
                        </td>
                      </tr>
                      <tr class="d-none">
                        <td>Shipment Delivered with Damage/Short Qty</td>
                        <td class="" v-for="t of trends" :key="t.month">
                          <a :href="makeTrendLink(t.month, t.from, t.to, 'disputed')">
                            {{t.dashboardEntry.disputed}}
                          </a>
                          <br />
                          <span class="text-danger">({{t.dashboardEntry.disputed_pct|toPct}}%)</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-6">
                  <column-chart :data="trendsChart" :colors="chartColors" :legend="false" :library="stackedBarOptions"></column-chart>

                  <table class="table table-borderless table-sm">
                    <thead class="thead-light">
                    <tr>
                      <th>Category</th>
                      <th v-for="m of trends" :key="m.month">{{m.month}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                        <span :style="makeBGColor(0)">&nbsp;&nbsp;</span>
                        POD Uploaded</td>
                      <td class="" v-for="t of trends" :key="t.month">{{t.dashboardEntry.uploaded}} </td>
                    </tr>
                    <tr>
                      <td>
                        <span :style="makeBGColor(1)">&nbsp;&nbsp;</span>
                        In-Transit</td>
                      <td class="" v-for="t of trends" :key="t.month">{{t.dashboardEntry.undelivered}} </td>
                    </tr>
                    <tr>
                      <td>
                        <span :style="makeBGColor(4)">&nbsp;&nbsp;</span>
                        POD Pending</td>
                      <td class="" v-for="t of trends" :key="t.month">{{t.dashboardEntry.pending}} </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>
            <b-tab title="Warehouse">
              <div class="row">
                <div class="col-12">
                  <table class="table table-borderless table-hover tbl-tr table-sm">
                    <thead class="thead-dark">
                    <tr>
                      <th>Name</th>
                      <th>Code</th>
                      <th><a class="pb-0" @click="sortWH('created')">
                        Created <i class="fa fa-angle-up" v-if="sortByWH === 'created' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'created' && sort === 'desc'"></i>
                      </a></th>
                      <th>
                        Service Invoice (NPD)
                      </th>
                      <th><a class="pb-0" @click="sortWH('cancelled')">
                        Cancelled <i class="fa fa-angle-up" v-if="sortByWH === 'cancelled' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'cancelled' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortWH('shipped')">
                        Shipped <i class="fa fa-angle-up" v-if="sortByWH === 'shipped' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'shipped' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortWH('delivered')">
                        Delivered <i class="fa fa-angle-up" v-if="sortByWH === 'delivered' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'delivered' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortWH('delivered_pct')">
                        Delivered %<i class="fa fa-angle-up" v-if="sortByWH === 'delivered_pct' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'delivered_pct' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortWH('undelivered')">
                        In-Transit <i class="fa fa-angle-up" v-if="sortByWH === 'undelivered' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'undelivered' && sort === 'desc'"></i>
                      </a></th>
                      <th>In-Transit %</th>
                      <th><a class="pb-0" @click="sortWH('returned')">
                        Returned <i class="fa fa-angle-up" v-if="sortByWH === 'returned' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'returned' && sort === 'desc'"></i>
                      </a></th>
                      <th>Returned %</th>
                      <th><a class="pb-0" @click="sortWH('uploaded')">
                        Uploaded <i class="fa fa-angle-up" v-if="sortByWH === 'uploaded' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'uploaded' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortWH('pending')">
                        Pending <i class="fa fa-angle-up" v-if="sortByWH === 'pending' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'pending' && sort === 'desc'"></i>
                      </a></th>
                      <th>Pending %</th>
                      <th><a class="pb-0" @click="sortWH('disputed')">
                        Bad POD <i class="fa fa-angle-up" v-if="sortByWH === 'disputed' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByWH === 'disputed' && sort === 'desc'"></i>
                      </a></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="t of locationChartTableSorted" :key="t.code">
                      <td>
                        <span v-if="locationCodeMap[t.code0]">{{locationCodeMap[t.code0].name}}</span>
                      </td>
                      <td>{{t.code}}</td>
                      <td><a :href="getLink('wh', t.code0, 'created')">{{t.created}}</a></td>
                      <td><a :href="getLink('wh', t.code0, 'services')">{{t.noshipping}}</a></td>
                      <td><a :href="getLink('wh', t.code0, 'cancelled')">{{t.cancelled}}</a></td>
                      <td><a :href="getLink('wh', t.code0, 'shipped')">{{t.shipped}}</a></td>
                      <td><a :href="getLink('wh', t.code0, 'delivered')">{{t.delivered}}</a></td>
                      <td><span class="text-success">{{t.delivered_pct|toPct}} %</span></td>
                      <td><a :href="getLink('wh', t.code0, 'undelivered')">{{t.undelivered}}</a></td>
                      <td><span class="text-danger">{{t.undelivered_pct|toPct}} %</span></td>
                      <td><a :href="getLink('wh', t.code0, 'returned')">{{t.returned}}</a></td>
                      <td><span class="text-danger">{{t.returned_pct|toPct}} %</span></td>
                      <td><a :href="getLink('wh', t.code0, 'uploaded')">{{t.uploaded}}</a></td>
                      <td><a :href="getLink('wh', t.code0, 'pending')">{{t.pending}}</a></td>
                      <td><span class="text-danger">{{t.pending_pct|toPct}} %</span></td>
                      <td><a :href="getLink('wh', t.code0, 'disputed')">{{t.disputed}}</a></td>
                    </tr>
                    </tbody>
                    <tfoot class="bg-dark text-white">
                    <tr>
                      <td colspan="2">Total</td>
                      <td>{{locationChartTotal.created}}</td>
                      <td>{{locationChartTotal.noshipping}}</td>
                      <td>{{locationChartTotal.cancelled}}</td>
                      <td>{{locationChartTotal.shipped}}</td>
                      <td>{{locationChartTotal.delivered}}</td>
                      <td>{{locationChartTotal.delivered_pct|toPct}} %</td>
                      <td>{{locationChartTotal.undelivered}}</td>
                      <td>{{locationChartTotal.undelivered_pct|toPct}} %</td>
                      <td>{{locationChartTotal.returned}}</td>
                      <td>{{locationChartTotal.returned_pct|toPct}} %</td>
                      <td>{{locationChartTotal.uploaded}}</td>
                      <td>{{locationChartTotal.pending}}</td>
                      <td>{{locationChartTotal.pending_pct|toPct}} %</td>
                      <td>{{locationChartTotal.disputed}}</td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </b-tab>
            <b-tab title="Transporter" v-if="isAdmin || isUser">
              <div class="row">
                <div class="col-11">&nbsp;</div>
                <div class="col-1">
                  <button class="btn btn-info btn-sm" @click.stop="downloadExcel()">
                    <i class="fa fa-download"></i> Excel
                  </button>
                </div>
                <div class="col-12 mt-3">
                  <table class="table table-borderless table-hover tbl-tr table-sm">
                    <thead class="thead-dark">
                    <tr>
                      <th>Name</th>
                      <th v-if="isAdmin">Type</th>
                      <th>Code</th>
                      <th>
                        <a class="pb-0" @click="sortTR('created')">
                          Assigned <i class="fa fa-angle-up" v-if="sortBy === 'created' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'created' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('delivered')">
                          Delivered <i class="fa fa-angle-up" v-if="sortBy === 'delivered' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'delivered' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('delivered_pct')">
                          Delivered % <i class="fa fa-angle-up" v-if="sortBy === 'delivered_pct' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'delivered_pct' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('undelivered')">
                          In-Transit <i class="fa fa-angle-up" v-if="sortBy === 'undelivered' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'undelivered' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('undelivered_pct')">
                          In-Transit % <i class="fa fa-angle-up" v-if="sortBy === 'undelivered_pct' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'undelivered_pct' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('returned')">
                          Returned <i class="fa fa-angle-up" v-if="sortBy === 'returned' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'returned' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>Returned %</th>
                      <th>
                        <a class="pb-0" @click="sortTR('uploaded')">
                          Uploaded <i class="fa fa-angle-up" v-if="sortBy === 'uploaded' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'uploaded' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('pending')">
                          Pending <i class="fa fa-angle-up"
                                                 v-if="sortBy === 'pending' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'pending' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('pending_pct')">
                          Pending % <i class="fa fa-angle-up" v-if="sortBy === 'pending_pct' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'pending_pct' && sort === 'desc'"></i>
                        </a>
                      </th>
                      <th>
                        <a class="pb-0" @click="sortTR('disputed')">
                          Bad POD <i class="fa fa-angle-up" v-if="sortBy === 'bad' && sort === 'asc'"></i>
                          <i class="fa fa-angle-down" v-if="sortBy === 'bad' && sort === 'desc'"></i>
                        </a>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="t of transporterChartTableSorted" :key="t.code">
                      <td>
                        <span v-if="trCodeMap[t.code0]">{{trCodeMap[t.code0].name}}</span>
                        <span class="text-danger" v-if="!trCodeMap[t.code0] || !t.code">LR NOT UPDATED</span>
                      </td>
                      <td v-if="isAdmin">
                        {{t.trType}}
                      </td>
                      <td>{{t.code}}</td>
                      <td><a :href="getLink('tr', t.code0, 'created')">{{t.created}}</a></td>
                      <td><a :href="getLink('tr', t.code0, 'delivered')">{{t.delivered}}</a></td>
                      <td><span class="text-success">{{t.delivered_pct|toPct}} %</span></td>
                      <td><a :href="getLink('tr', t.code0, 'undelivered')">{{t.undelivered}}</a></td>
                      <td><span class="text-danger">{{t.undelivered_pct|toPct}} %</span></td>
                      <td><a :href="getLink('tr', t.code0, 'returned')">{{t.returned}}</a></td>
                      <td><span class="text-danger">{{t.returned_pct|toPct}} %</span></td>
                      <td><a :href="getLink('tr', t.code0, 'uploaded')">{{t.uploaded}}</a></td>
                      <td><a :href="getLink('tr', t.code0, 'pending')">{{t.pending}}</a></td>
                      <td><span class="text-danger">{{t.pending_pct|toPct}} %</span></td>
                      <td><a :href="getLink('tr', t.code0, 'disputed')">{{t.disputed}}</a></td>
                    </tr>
                    </tbody>
                    <tfoot class="bg-dark text-white">
                    <tr>
                      <td colspan="2" v-if="!isAdmin">Total</td>
                      <td colspan="3" v-if="isAdmin">Total</td>
                      <td>{{transporterChartTotal.created}}</td>
                      <td>{{transporterChartTotal.delivered}}</td>
                      <td>{{transporterChartTotal.delivered_pct|toPct}} %</td>
                      <td>{{transporterChartTotal.undelivered}}</td>
                      <td>{{transporterChartTotal.undelivered_pct|toPct}} %</td>
                      <td>{{transporterChartTotal.returned}}</td>
                      <td>{{transporterChartTotal.returned_pct|toPct}}</td>
                      <td>{{transporterChartTotal.uploaded}}</td>
                      <td>{{transporterChartTotal.pending}}</td>
                      <td>{{transporterChartTotal.pending_pct|toPct}} %</td>
                      <td>{{transporterChartTotal.disputed}}</td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </b-tab>
            <b-tab title="Group" v-if="isAdmin || isUser">
              <div class="row">
                <div class="col-12 mt-3">
                  <table class="table table-borderless table-hover tbl-tr table-sm">
                    <thead class="thead-dark">
                    <tr>
                      <th>Group</th>
                      <th>Division</th>
                      <th><a class="pb-0" @click="sortGP('created')">
                        Created <i class="fa fa-angle-up" v-if="sortByGP === 'created' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'created' && sort === 'desc'"></i>
                      </a></th>
                      <th>
                        Service Invoice (NPD)
                      </th>
                      <th><a class="pb-0" @click="sortGP('cancelled')">
                        Cancelled <i class="fa fa-angle-up" v-if="sortByGP === 'cancelled' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'cancelled' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortGP('shipped')">
                        Shipped <i class="fa fa-angle-up" v-if="sortByGP === 'shipped' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'shipped' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortGP('delivered')">
                        Delivered <i class="fa fa-angle-up" v-if="sortByGP === 'delivered' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'delivered' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortGP('delivered_pct')">
                        Delivered %<i class="fa fa-angle-up" v-if="sortByGP === 'delivered_pct' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'delivered_pct' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortGP('undelivered')">
                        In-Transit <i class="fa fa-angle-up" v-if="sortByGP === 'undelivered' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'undelivered' && sort === 'desc'"></i>
                      </a></th>
                      <th>In-Transit %</th>
                      <th><a class="pb-0" @click="sortGP('returned')">
                        Returned <i class="fa fa-angle-up" v-if="sortByGP === 'returned' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'returned' && sort === 'desc'"></i>
                      </a></th>
                      <th>Returned %</th>
                      <th><a class="pb-0" @click="sortGP('uploaded')">
                        Uploaded <i class="fa fa-angle-up" v-if="sortByGP === 'uploaded' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'uploaded' && sort === 'desc'"></i>
                      </a></th>
                      <th><a class="pb-0" @click="sortGP('pending')">
                        Pending <i class="fa fa-angle-up" v-if="sortByGP === 'pending' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'pending' && sort === 'desc'"></i>
                      </a></th>
                      <th>Pending %</th>
                      <th><a class="pb-0" @click="sortGP('disputed')">
                        Bad POD <i class="fa fa-angle-up" v-if="sortByGP === 'disputed' && sort === 'asc'"></i>
                        <i class="fa fa-angle-down" v-if="sortByGP === 'disputed' && sort === 'desc'"></i>
                      </a></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="t of groupChartTableSorted" :key="t.code">
                      <td>{{t.group}}</td>
                      <td>{{t.code}}</td>
                      <td><a :href="getLink('gp', t.code, 'created')">{{t.created}}</a></td>
                      <td><a :href="getLink('gp', t.code, 'services')">{{t.noshipping}}</a></td>
                      <td><a :href="getLink('gp', t.code, 'cancelled')">{{t.cancelled}}</a></td>
                      <td><a :href="getLink('gp', t.code, 'shipped')">{{t.shipped}}</a></td>
                      <td><a :href="getLink('gp', t.code, 'delivered')">{{t.delivered}}</a></td>
                      <td><span class="text-success">{{t.delivered_pct|toPct}} %</span></td>
                      <td><a :href="getLink('gp', t.code, 'undelivered')">{{t.undelivered}}</a></td>
                      <td><span class="text-danger">{{t.undelivered_pct|toPct}} %</span></td>
                      <td><a :href="getLink('gp', t.code, 'returned')">{{t.returned}}</a></td>
                      <td><span class="text-danger">{{t.returned_pct|toPct}} %</span></td>
                      <td><a :href="getLink('gp', t.code, 'uploaded')">{{t.uploaded}}</a></td>
                      <td><a :href="getLink('gp', t.code, 'pending')">{{t.pending}}</a></td>
                      <td><span class="text-danger">{{t.pending_pct|toPct}} %</span></td>
                      <td><a :href="getLink('gp', t.code, 'disputed')">{{t.disputed}}</a></td>
                    </tr>
                    </tbody>
                    <tfoot class="bg-dark text-white">
                    <tr>
                      <td colspan="2">Total</td>
                      <td>{{groupChartTotal.created}}</td>
                      <td>{{groupChartTotal.noshipping}}</td>
                      <td>{{groupChartTotal.cancelled}}</td>
                      <td>{{groupChartTotal.shipped}}</td>
                      <td>{{groupChartTotal.delivered}}</td>
                      <td>{{groupChartTotal.delivered_pct|toPct}} %</td>
                      <td>{{groupChartTotal.undelivered}}</td>
                      <td>{{groupChartTotal.undelivered_pct|toPct}} %</td>
                      <td>{{groupChartTotal.returned}}</td>
                      <td>{{groupChartTotal.returned_pct|toPct}} %</td>
                      <td>{{groupChartTotal.uploaded}}</td>
                      <td>{{groupChartTotal.pending}}</td>
                      <td>{{groupChartTotal.pending_pct|toPct}} %</td>
                      <td>{{groupChartTotal.disputed}}</td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'PODHomePage',
  data () {
    return {
      activeTab: 0,
      updating: false,
      pods: {
        created: 0,
        delivered: 0,
        undelivered: 0,
        cancelled: 0,
        noshipping: 0,
        shipped: 0,
        returned: 0,
        uploaded: 0,
        pending: 0,
        disputed: 0,
        resolved: 0
      },
      options: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        keepOpen: false,
        collapse: false,
        toolbarPlacement: 'bottom',
        showTodayButton: false,
        showClose: false,
        debug: false
      },
      stackedBarOptions: {
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      },
      saleType: [],
      saleTypes: ['STR', 'SAL', 'SAM'],
      fromDate: moment().startOf('month').toDate(),
      toDate: moment().toDate(),
      period: 'current',
      aggregate: 'COUNT',
      location: 0,
      group: '0',
      division: '0',
      transporter: 0,
      groups: [],
      locations: [],
      trCodeMap: {},
      trTypeMap: {},
      grpMap: {},
      locationCodeMap: {},
      transporters: [],
      locationChartTable: [],
      groupChartTable: [],
      transporterChartTable: [],
      transporterChartTableSorted: [],
      locationChartTableSorted: [],
      groupChartTableSorted: [],
      locationChartTotal: {},
      transporterChartTotal: {},
      groupChartTotal: {},
      pieChart: [],
      locChart: [],
      trChart: [],
      sort: 'asc',
      sortBy: 'created',
      sortByWH: 'created',
      sortByGP: 'created',
      chartColors: [],
      cardColors: [],
      trends: [],
      trendsChart: []
    }
  },
  watch: {
    period: function (newPeriod, oldPeriod) {
      if (newPeriod === 'custom') {
        console.log('custom period, just enable from and to')
      } else if (newPeriod === 'current') {
        this.fromDate = moment().startOf('month').toDate()
        this.toDate = moment().toDate()
      } else if (newPeriod === 'last') {
        this.fromDate = moment().startOf('month').subtract(1, 'month').toDate()
        this.toDate = moment().startOf('month').subtract(1, 'day').toDate()
      } else {
        console.log('unknown period', newPeriod)
      }
      let data = {
        period: newPeriod,
        fromDate: this.fromDate,
        toDate: this.toDate,
        dashLocation: this.location,
        dashTransporter: this.transporter,
        aggregate: this.aggregate,
        saleTypes: this.saleType
      }
      this.$store.commit('setHomePageDate', data)
    }
  },
  created: function () {
    let colors = ['#007bff', '#e83e8c', '#ffc107', '#28a745', '#fd7e14', '#6f42c1', '#17a2b8', '#dc3545', '#6610f2', '#20c997']
    this.period = this.$store.state.period
    this.fromDate = this.$store.state.fromDate
    this.toDate = this.$store.state.toDate
    this.activeTab = this.$store.state.tab
    this.location = this.$store.state.dashLocation
    this.transporter = this.$store.state.dashTransporter
    this.group = this.$store.state.group
    this.division = this.$store.state.division
    this.aggregate = this.$store.state.aggregate
    this.saleType = this.$store.state.saleTypes
    this.chartColors = colors.map(c => this.hexToRgbA(c, 0.8))
    this.cardColors = colors.map(c => this.hexToRgbA(c, 1))
    console.log('created', this.period, this.fromDate, this.toDate, 'active tab', this.activeTab, 'location', this.location, 'transporter', this.transporter, 'division', this.division, 'group', this.group)
    this.$store.dispatch('isLoggedIn').then(() => {
      this.groups = new Set(this.$store.state.divisions.map(d => d.group.trim()))
      console.log('global locations', this.groups)
      this.loadDashboard()
    }, err => {
      console.error('error in login check', err)
      this.$router.push('/login')
    })
  },
  computed: {
    today: function () {
      return moment().format('MMMM Do YYYY')
    },
    isTransporter: function () {
      return this.$store.state.isTransporter
    },
    isUser: function () {
      return this.$store.state.isRegularUser
    },
    isAdmin: function () {
      return this.$store.state.adminLoggedIn
    },
    chartUrlv3: function () {
      let path = '/pod-app/chart/dashboard-v2-all'
      let fromStr = this.fromDateTxt
      let toStr = this.toDateTxt
      return `${path}?fromDate=${fromStr}&toDate=${toStr}&location=${this.location}&transporter=${this.transporter}&group=${this.group}&division=${this.division}&aggregate=${this.aggregate}&saletypes=${this.saleType.join(',')}`
    },
    divisions: function () {
      let group = this.group
      let divisionList = []
      if (group !== '0') {
        divisionList = this.$store.state.divisions.filter(d => d.group === group).map(d => d.division)
      }
      console.log('local divisions', group, divisionList, this.$store.state.divisions)
      return divisionList
    },
    saleTypeText: function () {
      return this.saleType.join(',')
    },
    divisionURL: function () {
      if (this.division === 0) {
        return 0
      }
      return this.division.replace(' ', '_')
    },
    fromDateTxt () {
      return moment(this.fromDate).format('YYYY-MM-DD')
    },
    toDateTxt () {
      return moment(this.toDate).format('YYYY-MM-DD')
    }
  },
  methods: {
    groupChanged: function () {
      this.division = 0
    },
    tabChanged: function (newTab) {
      console.log('new tab selected is', newTab)
      this.$store.commit('setTab', newTab)
    },
    makeTrendLink: function (m, f, t, w) {
      return `#/manage-pod/${f}/${t}/${this.location}/${this.transporter}/${w}/${this.group}/${this.divisionURL}/${this.saleTypeText}`
    },
    hexToRgbA: function (hex, opacity) {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        let r = (c >> 16) & 255
        let g = (c >> 8) & 255
        let b = c & 255
        return `rgba(${r}, ${g}, ${b}, ${opacity})`
      }
      throw new Error('Bad Hex')
    },
    makeBGColor: function (idx) {
      return `background-color: ${this.cardColors[idx]}`
    },
    sortTR: function (what) {
      if (what === this.sortBy) {
        if (this.sort === 'asc') {
          this.sort = 'desc'
        } else {
          this.sort = 'asc'
        }
      } else {
        this.sortBy = what
        this.sort = 'desc'
      }

      console.log('TR sort by', this.sortBy, 'order', this.sort)
      this.transporterChartTableSorted = _.orderBy(this.transporterChartTable, [this.sortBy], [this.sort])
    },
    sortGP: function (what) {
      if (what === this.sortByGP) {
        if (this.sort === 'asc') {
          this.sort = 'desc'
        } else {
          this.sort = 'asc'
        }
      } else {
        this.sortByGP = what
        this.sort = 'desc'
      }

      console.log('GP sort by', this.sortByGP, 'order', this.sort)
      this.groupChartTableSorted = _.orderBy(this.groupChartTable, ['group', this.sortByGP], ['asc', this.sort])
    },
    sortWH: function (what) {
      if (what === this.sortByWH) {
        if (this.sort === 'asc') {
          this.sort = 'desc'
        } else {
          this.sort = 'asc'
        }
      } else {
        this.sortByWH = what
        this.sort = 'desc'
      }

      console.log('WH sort by', this.sortByWH, 'order', this.sort)
      this.locationChartTableSorted = _.orderBy(this.locationChartTable, [this.sortByWH], [this.sort])
    },
    getUrl: function (wh) {
      return `#/manage-pod/${this.fromDateTxt}/${this.toDateTxt}/${this.location}/${this.transporter}/${wh}/${this.group}/${this.divisionURL}/${this.saleTypeText}`
    },
    getLink: function (which, code, wh) {
      let part = `#/manage-pod/${this.fromDateTxt}/${this.toDateTxt}`
      let location = 0
      let transporter = 0
      let division = '0'
      let group = '0'
      if (which === 'wh') {
        let f = this.locations.filter(l => l.codes.includes(code))
        if (f.length > 0) {
          location = f[0].id
        }
        transporter = this.transporter
        group = this.group || '0'
        division = this.division || '0'
      } else if (which === 'tr') {
        let tr = this.transporters.filter(l => l.code === code)
        if (tr.length > 0) {
          transporter = tr[0].id
        }
        location = this.location
        group = this.group || '0'
        division = this.division || '0'
      } else {
        division = code
        transporter = this.transporter || '0'
        location = this.location || '0'
        let filter = this.$store.state.divisions.filter(d => d.division === code)
        if (filter.length > 0) {
          group = filter[0].group
        }
      }
      return `${part}/${location}/${transporter}/${wh}/${group}/${division.replace(' ', '_')}/${this.saleTypeText}`
    },
    loadDashboard: function () {
      // save data to localStorage
      let data = {
        period: this.period,
        fromDate: this.fromDate,
        toDate: this.toDate,
        dashLocation: this.location,
        dashTransporter: this.transporter,
        group: this.group,
        aggregate: this.aggregate,
        division: this.division,
        saleTypes: this.saleType
      }
      this.$store.commit('setHomePageDate', data)
      this.updating = true
      axios.get(this.chartUrlv3)
        .then((v3resp) => {
          this.transporters = this.$store.state.transporters
          this.transporters.forEach(t => {
            this.trCodeMap[t.code] = t
            this.trTypeMap[t.code] = t['type']
          })

          this.locations = this.$store.state.locations.filter(l => l.enabled !== false)
          this.locations.forEach(l => {
            l.codes.forEach(c => {
              this.locationCodeMap[c] = l
            })
          })

          this.$store.state.divisions.forEach(d => {
            this.grpMap[d.division] = d.group
          })

          let resp = v3resp.data['all'][0]
          let location = v3resp.data['location']
          let transporter = v3resp.data['transporter']
          let group = v3resp.data['group']

          let overall = resp.second
          this.pods.created = overall.created
          this.pods.shipped = overall.shipped
          this.pods.noshipping = overall.noshipping
          this.pods.cancelled = overall.cancelled
          this.pods.delivered = overall.delivered
          this.pods.undelivered = overall.undelivered
          this.pods.returned = overall.returned
          this.pods.uploaded = overall.uploaded
          this.pods.pending = overall.pending
          this.pods.disputed = overall.disputed
          this.trends = v3resp.data['trends']
          this.pieChart = [
            {name: 'Created', data: {'': this.pods.created}},
            {name: 'Delivered', data: {'': this.pods.delivered}},
            {name: 'Service Invoice (NPD)', data: {'': this.pods.noshipping}},
            {name: 'Cancelled', data: {'': this.pods.cancelled}},
            {name: 'Shipped', data: {'': this.pods.shipped}},
            {name: 'Returned', data: {'': this.pods.returned}},
            {name: 'Uploaded', data: {'': this.pods.uploaded}},
            {name: 'Pending', data: {'': this.pods.pending}},
            {name: 'Bad POD', data: {'': this.pods.disputed}}
          ]
          let makeData = (rows, what) => {
            let d = {}
            rows.forEach(row => {
              d[row.month] = row.dashboardEntry[what]
            })
            return d
          }
          let makeChartData = (rows) => {
            return rows
              .filter(row => row.first.indexOf('CNL') === -1)
              .map(row => {
                return {
                  code0: row.first.split(',')[0],
                  code: row.first,
                  created: row.second.created,
                  noshipping: row.second.noshipping,
                  delivered: row.second.delivered,
                  undelivered: row.second.undelivered,
                  cancelled: row.second.cancelled,
                  shipped: row.second.shipped,
                  delivered_pct: row.second.delivered_pct,
                  undelivered_pct: row.second.undelivered_pct,
                  returned: row.second.returned,
                  uploaded: row.second.uploaded,
                  pending: row.second.pending,
                  pending_pct: row.second.pending_pct,
                  returned_pct: row.second.returned_pct,
                  disputed: row.second.disputed
                }
              })
          }
          let makeTotal = (rows) => {
            let r = {
              created: 0,
              cancelled: 0,
              noshipping: 0,
              shipped: 0,
              delivered: 0,
              uploaded: 0,
              returned: 0,
              undelivered: 0,
              pending: 0,
              disputed: 0
            }
            rows.forEach(row => {
              r.created += row.created
              r.noshipping += row.noshipping
              r.cancelled += row.cancelled
              r.shipped += row.shipped
              r.delivered += row.delivered
              r.uploaded += row.uploaded
              r.returned += row.returned
              r.undelivered += row.undelivered
              r.pending += row.pending
              r.disputed += row.disputed
            })

            r['delivered_pct'] = r.delivered * 100 / r.shipped
            r['undelivered_pct'] = r.undelivered * 100 / r.shipped
            r['returned_pct'] = r.returned * 100 / r.shipped
            let podRequired = r.delivered + r.returned
            let podPending = podRequired - r.uploaded
            r['pending_pct'] = podPending * 100 / podRequired

            return r
          }
          this.trendsChart = [
            {name: 'POD Uploaded', data: makeData(this.trends, 'uploaded')},
            {name: 'In-Transit', data: makeData(this.trends, 'undelivered')},
            {name: 'POD Pending', data: makeData(this.trends, 'pending')}
          ]
          this.locationChartTable = makeChartData(location)
          this.locationChartTotal = makeTotal(this.locationChartTable)

          this.transporterChartTable = makeChartData(transporter).map(t => {
            t['trType'] = this.trTypeMap[t.code]
            return t
          })
          this.transporterChartTotal = makeTotal(this.transporterChartTable)

          this.groupChartTable = makeChartData(group).map(r => {
            r['group'] = this.grpMap[r.code]
            return r
          })
          this.groupChartTotal = makeTotal(this.groupChartTable)
          this.sortTR('created')
          this.sortWH('created')
          this.sortGP('created')
          this.updating = false
        })
    },
    downloadExcel: function () {
      let csvBody = this.transporterChartTableSorted.map(t => {
        return [
          (this.trCodeMap[t.code0] || {name: ''}).name,
          t.code,
          t.created,
          t.delivered,
          t.delivered_pct,
          t.returned,
          t.returned_pct,
          t.uploaded,
          t.pending,
          t.pending_pct,
          t.disputed
        ].join(',')
      }).join('\n')
      let csvHeader = 'Name,Code,Assigned,Delivered,Delivered %,Returned,Returned %,Uploaded,Pending,Pending %,Bad POD'
      let csv = `${csvHeader}\n${csvBody}`
      let csvEncoded = encodeURI(csv)
      let downloadUrl = `data:text/csv;charset=utf-8,${csvEncoded}`
      let link = document.createElement('a')
      link.setAttribute('href', downloadUrl)
      link.setAttribute('download', `transporter_status_${this.fromDateTxt}_${this.toDateTxt}.csv`)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
<style scoped>
  a {
    cursor: pointer;
  }

  .tbl-tr thead th a {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }

  .tbl-tr thead th a i:first-child {
    margin-left: 5px;
  }

  .card-footer {
    font-size: small;
  }
  input, select {
    font-size: smaller;
  }
  .form-control {
    margin-right: .25rem!important;
  }

  .pod-home-page .card-deck .card .card-header {
    padding: .5rem !important;
  }

  .pod-home-page .card-deck {
    margin: 5px;
  }

  .pod-home-page .card-deck .card {
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PODHomePage.vue